import React from "react";
import c from "./styles.module.scss";
import Container from "../container";
import PostItem from "../postItem";
import Spinner from "../spinner";
import useCosmic from "../../hooks/useCosmic";

const BlogFeed = () => {
	const { posts, error, loading } = useCosmic(1000);

	return (
		<section className={c.blogFeed}>
			<Container>
				<div className={c.feedInner}>
					{error && <h2>{error}</h2>}
					{loading && <Spinner />}
					{!loading &&
						!error &&
						posts.map((post) => <PostItem key={post.slug} post={post} />)}
				</div>
			</Container>
		</section>
	);
};

export default BlogFeed;
